import * as els from './halfPageManagerElements';
import * as consts from './halfPageManagerConstants';

export const halfPageManagerInitTopAd = (): void => {
  // Jeden aside blok s reklamami na stránce
  // Na začátku se nachází pozice 311 s výškou 600 - 2399 px
  // Případ dvou bloků s pozicí 311 v horním bloku samotně se řeší čistě přes CSS
  if (!els.topAside) {
    return;
  }

  const topContentHeight: number = (els.topContent as HTMLElement).offsetHeight;

  // Výšku top banneru nastavujeme jen pokud bottom prvky neexistují na stránce
  if (els.topBanner && !els.bottomAside) {
    els.topBanner.style.height = `
    ${
      topContentHeight < consts.HALFPAGE_WRAPPER_MAX_HEIGHT
        ? topContentHeight
        : consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT
    }px`;
  }
};
